import { Route } from "@angular/router";
import { LoginRecoverEmailAddressComponent } from "@modules/login-recover-email-address/components/login-recover-email-address/login-recover-email-address.component";

export const LOGIN_RECOVER_EMAIL_ADDRESS_ROUTES: Route[] = [
    {
        path: '',
        component: LoginRecoverEmailAddressComponent,
    }
];